export async function sha256(value: string): Promise<string> {
	const normalized = value.trim().toLowerCase();
	const encoder = new TextEncoder();
	const data = encoder.encode(normalized);
	const hashBuffer = await crypto.subtle.digest("SHA-256", data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function hashAudienceData(
	rows: string[][],
	columnMapping: string[],
): Promise<{ schema: string[]; hashedData: string[][] }> {
	const schema = columnMapping.filter((col) => col !== "SKIP");
	const columnIndices = columnMapping
		.map((col, i) => (col !== "SKIP" ? i : -1))
		.filter((i) => i !== -1);

	const BATCH_SIZE = 500;
	const hashedData: string[][] = [];

	for (let i = 0; i < rows.length; i += BATCH_SIZE) {
		const batch = rows.slice(i, i + BATCH_SIZE);
		const hashedBatch = await Promise.all(
			batch.map(async (row) => {
				const values = columnIndices.map((idx) => row[idx] ?? "");
				return Promise.all(values.map((v) => sha256(v)));
			}),
		);
		hashedData.push(...hashedBatch);
	}

	return { schema, hashedData };
}
